import { render, staticRenderFns } from "./FormControlTypeTime.vue?vue&type=template&id=1d421a78"
import script from "./FormControlTypeTime.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTypeTime.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports